import {
    Box,
    Button,
    Grid,
    makeStyles,
    Paper,
    TextField,
    Typography,
  } from "@material-ui/core";
  import { ARBITRATION, ARBITRATOR, IO_INPROGRESS, MD_INPROGRESS, REOPEN_INPROGRESS, RESPONDENT_INPROGRESS } from "app/constants";
  import React, { useEffect, useState } from "react";
  import { useHistory } from "react-router-dom";
  import { DocGenerator } from "utils";
  import { orixCaseResolved, setSucessfullGet, updateDispute, forwardOrixCase } from "slices/disputeSlice";
  import CircularCenteredLoader from "features/common/CircularCenteredLoader";
import { KeyboardBackspace, PlayForWork } from "@material-ui/icons";
import { format } from "date-fns";
import { useBackground } from "contexts/BackgroundContext";
import { updateCase } from "slices/casesSlice";
import { useDispatch } from "react-redux";
import { useResumeFilling } from "contexts/ResumeFilling";
import { calc_days } from "./utils/util";
import { getClaimantAnswerData, getCaseTimeline, markDisputeAsSeen, getReasonsForRejection } from "./API/service";
import TimelineComponent from "Components/Timelines";
import Swal from "sweetalert2";
  
  const useStyles = makeStyles((theme) => ({
		root: {
			marginTop: "2rem",
			[theme.breakpoints.down("sm")]: {
				marginTop: "1.5rem",
			},
			[theme.breakpoints.down("xs")]: {
				marginTop: "1rem",
			},
		},
    text: {
      fontFamily: `"Inter", "sans-serif"`,
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "16px",
      lineHeight: "24px",
    },
    blue: {
      fontFamily: `"Inter", "sans-serif"`,
      color: "#2F80ED",
      lineHeight: "24px",
    },
    fonts: {
      lineHeight: "24px",
      fontSize: "16px",
      fontFamily: `"Inter", "sans-serif"`,
    },
    item: {
      "&:hover": {
        background: "#EEEEEE",
      },
    },
		claimantDetailsContainer: {
			display: "flex",
			flexDirection: "column",
			width: "100%",
			padding: "2rem",
			borderRadius: '4px',
			backgroundColor: '#f4f8ff',
		},
		claimantDetailsHeading: {
			marginBottom: "1rem",
			fontSize:'1.5rem',
			lineHeight:'1.8rem',
			color:'black'
		},
		claimantDetailsStatus: {
			borderRadius:'4px',
			padding:'8px',
			width:'fit-content',
			lineHeight:1,
		},
		claimantDetailsRow: {
			padding: '10px 0',
			borderBottom: '1px solid #d7dbe2',
			display: 'flex',
			gap: '10px',
			[theme.breakpoints.between("sm",'md')]: {
				display: 'block',
      },
		},
		disputeStatusContainer: {
			display: "flex",
			flexDirection: "column",
			width: "100%",
			padding: "0.8rem 1rem 0.8rem 3rem",
		},
		disputeStatusHeading: {
			marginBottom: "0.5rem",
			fontSize:'1.3rem',
			lineHeight:'1.8rem',
			color:'black'
		},
		button: {
			color: 'black',
			"&:disabled": {
				backgroundColor: '#0000001f',
				color: '#00000042',
			}
		},
		titleText: {
			fontSize: "1.5em",
			fontWeight: 500,
		}
  }));

  export default function DisputeDetailsOrix({
    activeDispute,
    activeCase,
    profile,
  }) {
    const classes = useStyles();
    const history = useHistory();
		const {setBackground} = useBackground();
    const dispatch = useDispatch();
		const { setResume } = useResumeFilling();

    const IS_ARBITRATOR = profile?.profile_type === ARBITRATOR;
		const IS_END_USER = profile?.profile_type === 'general';
		const IS_GRC = profile?.profile_type === 'vendor';
		const IS_IO = profile?.profile_type === 'mediator';
		const viewer_role = IS_END_USER ? 'claimant' : IS_IO ? 'IO' : IS_ARBITRATOR ? 'GRO' : 'GRC';
		const IS_TAG_CHANGE_ALLOWED = IS_GRC && activeDispute?.customer_type === 'UNKNOWN';
  
    const [loading, setLoading] = React.useState(true);
    const [claimant, setClaimant] = React.useState("");
		const [complainantData, setComplainantData] = React.useState([]);
		const [timeline, setTimeLine] = useState([]);
		const [claimantAnswerData, setClaimantAnswerData] = useState({});
		const [buttonResponse, setButtonResponse] = useState('');
		const [reasonForRejection, setReasonForRejection] = useState('');
    const [reasonForRejectionOptions, setReasonsForRejection] = useState([]);

    React.useEffect(() => {
			setBackground('white');
			getClaimantAnswerData(activeDispute?.id).then((res) => {
				const answerData = res.data?.answers
				const tempObject = answerData.reduce(
					(obj, item) => Object.assign(obj, { [item.question_text]: {question_id:item.question_id, question: item.question_text, answer:item.answer_value, ...item} }), {}
				);
				setClaimantAnswerData(tempObject);
				setClaimant(res.data?.complainant?.[0]);
				setLoading(false);
			})
			getCaseTimeline(activeDispute?.id)
      .then((res)=>{
        setTimeLine(res.data);
      })
			if(activeDispute?.unread?.includes(profile?.profile_type)){
				markDisputeAsSeen(activeDispute?.id);
			}
    }, []);

		useEffect(() => {
			const tempArr = [
				{
					question: 'Ticket Number',
					answer: activeDispute?.grc_ticket_number,
				},
				// ...(IS_ARBITRATOR ? 
				// 	[{
				// 		question: 'GRC Ticket Number',
				// 		answer: activeDispute?.grc_ticket_number,
				// 	}] : []
				// ),
				{
					question: 'Email',
					answer: claimant?.email,
				},
				{
					question: 'Complaint Category',
					get answer() {
						return claimantAnswerData[this.question]?.ground || '--';
					},
				},
				...(Object.hasOwn(claimantAnswerData, "Sub Complaint Category") ? 
					[{
						question: "Sub Complaint Category",
						get answer() {
							return claimantAnswerData[this.question]?.ground || '--';
						},
					}] : []
				),
				{
					question: 'Phone No.',
					answer: claimant?.phone_number,
				},
				{
					question: 'Loan No./Booking No./Schedule No./Disbursement No.',
					answer: activeDispute?.loan_or_booking_number,
				},
				{
					question: 'Business Vertical',
					answer: activeDispute?.customer_type,
				},
				{
					question: 'Request Ticket No.',
					answer: activeDispute?.request_ticket_number,
				},
				{
					question: 'State',
					answer: activeDispute?.state,
				},
				{
					question: 'City',
					answer: activeDispute?.city,
				},
			]
			setComplainantData(tempArr);
		}, [claimant, claimantAnswerData]);

    const download = (e) => {
      e.stopPropagation();
			const params = {
				primary_details: true
			}
      DocGenerator(activeDispute.id, "claimant", '', params);
    };

		const handleDownloadResponse = () => {
			const profile_type = activeDispute?.gro_ticket_number ? 'gro' : 'respondent';
			DocGenerator(activeDispute.id, profile_type);
		}

		const handleDownloadResponseTimeline = (status, downloadKey) => {
			DocGenerator(activeDispute.id, status, downloadKey);
		}

		function ComplainantDetails({title, tag, complainantData}) {
			return (
				<Paper className={classes.claimantDetailsContainer}>
					<Typography className={classes.claimantDetailsHeading}>
						{title}
					</Typography>
					<Typography className={classes.claimantDetailsStatus} style={activeDispute.status === 'closed' ? {backgroundColor: '#caf4d1'} : {backgroundColor:'#ffefeb'}}>
						{tag}
					</Typography>
					{complainantData.map((item,index) => {
						return (
							<Box key={index} className={classes.claimantDetailsRow}>
								<Grid
									container
									justify="space-between"
									spacing={1}
								>
									<Grid item xs={6}>
										<Typography className={classes.boldText}>
											{item.question}
										</Typography>
									</Grid>
									<Grid item xs={6} style={{textAlign:'right'}}>
										<Typography>
											{item.answer}
										</Typography>
									</Grid>
								</Grid>
							</Box>
						)
					})}
					<Box className={classes.claimantDetailsRow} style={{border:'none',marginTop:'0.5rem'}}>
						<Button
							variant="outlined"
							fullWidth
							style={{color:'black', backgroundColor: 'white'}}
							startIcon={<PlayForWork/>}
              onClick={download}
						>
							Download Complaint
						</Button>
						<Box style={{height:'1rem'}}/>
						{IS_END_USER && (
							<Button
								className={classes.button}
								variant="outlined"
								fullWidth
								style={{backgroundColor: 'white'}}
								startIcon={<PlayForWork/>}
								onClick={handleDownloadResponse}
								disabled={activeDispute.status !== 'closed'}
							>
								Download Response
							</Button>
						)

						}
					</Box>
				</Paper>
			);
		}

		function TrackProgress() {
			return (
				<Paper className={classes.disputeStatusContainer}>
					<Typography className={classes.disputeStatusHeading}>
						{activeDispute.status === 'closed' ? 'Resolved' : 'In Progress'}
					</Typography>
					<Box style={{display:'flex',alignItems:'center',gap:'1rem', paddingBottom:'8px', borderBottom:'1px solid #dfdfdf'}}>
						<Typography style={{color:'#4b4e56',fontFamily: 'Satoshi-Bold'}}>
							Updated
						</Typography>
						<Typography>
							{format(new Date(activeDispute?.modified), "dd MMMM, y, h:mm a")}
						</Typography>
					</Box>
					<Box>
						<TimelineComponent
							timelineData={timeline}
							handleDownloadFile={handleDownloadResponseTimeline}
							isDownloadable={true}
							downloadText={'Review'}
						/>
					</Box>
				</Paper>
			);
		}

		const handleClickRecordResponse = () => {
			const casePayload = { 
				proposed_flow: ARBITRATION, 
				id: activeCase.id 
			}
			const endUserCasePayload = { 
				case_status: 'new', 
				id: activeCase.id,
				proposed_flow: ARBITRATION, 
			}
			dispatch(
				updateCase(IS_END_USER ? endUserCasePayload : casePayload)
			)
			.then((response) => {
				let disputePayload = {
					id: activeDispute.id,
					status: IS_IO ? MD_INPROGRESS : IS_ARBITRATOR ? IO_INPROGRESS : RESPONDENT_INPROGRESS,
					flow_type: ARBITRATION,
				};
				!IS_END_USER && dispatch(updateDispute(disputePayload));
				setResume(true);
			})
			.catch((err) => {
				console.log(err);
			});
		}

		const handleCloseGrievance = () => {
			Swal.fire({
				titleText: "Are you sure you want to close the grievance?",
				showCancelButton: true,
				confirmButtonText: 'Close Grievance',
				focusCancel: true,
				confirmButtonColor: '#4A3BFF',
				customClass: {
					title: classes.titleText,
				}
			}).then((result) => {
				if (result.isConfirmed) {
					dispatch(orixCaseResolved(activeDispute.id))
				}
			})
		}

		const handleForwardGrievance = () => {
			Swal.fire({
				titleText: "Are you sure you want to forward this case to next level?",
				showCancelButton: true,
				confirmButtonText: 'Forward',
				focusCancel: true,
				confirmButtonColor: '#4A3BFF',
				customClass: {
					title: classes.titleText,
				}
			}).then((result) => {
				if (result.isConfirmed) {
					const casePayload = { 
						status: buttonResponse?.toLowerCase(),
						reason: reasonForRejection,
					}
					dispatch(
						forwardOrixCase(activeDispute.id, casePayload)
					)
					// dispatch(setSucessfullGet({...activeDispute, status: REOPEN_INPROGRESS}));
				}
			})
		}

		const dateToBeUse = () => {
			// if(IS_ARBITRATOR){
			// 	return activeDispute?.reopen_date;
			// } else if(IS_GRC){
			// 	return activeDispute?.submission_date;
			// } else {
			// 	return activeDispute?.reopen_date ? activeDispute?.reopen_date : activeDispute?.submission_date;
			// }
			return activeDispute?.submission_date;
		}

		const getRespondOptions = () => {
			if(IS_IO) {
				return ['Agree with ORIX', 'Disagree with ORIX'];
			} else if (IS_ARBITRATOR) {
				if(activeDispute?.orix_status === 'GRO_after_IO'){
					return ['Agree with IO', 'Disagree with IO', 'Partially agree with IO'];
				} else {
					return ['Agree with GRC', 'Disagree with GRC'];
				}
			} else {
				return ['Acknowledged', 'Rejected', 'Partially Rejected'];
			}
		}

		const respondOptions = getRespondOptions();
		// const reasonForRejectionOptions = ['Commercial Decision', 'Complaint Pending in any other forum (Court/Consumer Disputes Redressal etc)', 'Corporate Frauds and Misappropriation', 'Internal Admin, HR, Pay & emoluments of Staff (Staff Related Issues)', 'Miscellaneous/Others', "Resolution under section 18 of CIC Act'2005"];

    const handleClickButtonResponse = (event) => {
      const value = event.target.value;
      setButtonResponse(value);
      if(['Rejected', 'Partially Rejected'].includes(value)){
        getReasonsForRejection().then((res) => {
          setReasonsForRejection(res?.data)
        })
      }
    }

		const getOrixRole = (orixStatus) => {
			switch(orixStatus) {
				case 'forward_IO':
					return 'IO';
				case 'forward':
				case 'GRO_after_IO':
					return 'GRO';
				case 'null':
				case 'GRC_after_GRO':
					return 'GRC';
				default:
					return 'GRC';
			}
		}

		const handleBusinessVerticalChange = (event) => {
			const value = event.target.value;
			let disputePayload = {
				id: activeDispute.id,
				customer_type: value,
			};
			dispatch(updateDispute(disputePayload));
		}
    
    if (loading) return <CircularCenteredLoader />;
  
    return (
      <Grid container justify="center" style={{backgroundColor: 'white', height:'100%'}}>
				<Grid item lg={11} md={10} sm={11} xs={11} className={classes.root}>
					<Button
						disableElevation
						disableFocusRipple
						disableRipple
						disableTouchRipple
						style={{ backgroundColor: "transparent", cursor: "default" }}
					>
						<Grid container spacing={1}>
							<Grid item>
								<Typography
									className={classes.btntext}
									style={{ color: "black", cursor: 'pointer' }}
									onClick={() => {
										history.goBack();
									}}
								>
									<KeyboardBackspace />
								</Typography>
							</Grid>
							<Grid item>
								<Typography
									className={`${classes.btntext} ${classes.hov}`}
									style={{ cursor: "pointer" }}
									onClick={() => {
										history.push("/");
									}}
								>
									Dashboard
								</Typography>
							</Grid>
							<Grid item>
								<Typography
									className={classes.btntext}
									style={{ color: "black" }}
								>
									/
								</Typography>
							</Grid>
							<Grid item>
								<Typography
									className={`${classes.btntext} ${classes.hov}`}
									style={{ cursor: "pointer" }}
									onClick={() => {
										history.push(`/disputes/${activeDispute.id}/`);
									}}
								>
									{activeDispute.name}
								</Typography>
							</Grid>
						</Grid>
					</Button>
					<Grid container style={{justifyContent:'space-between', gap:'2rem', alignItems:'center'}}>
            <Grid item xs>
              <Typography className="lineClamp" style={{fontFamily:'Satoshi-Bold'}}>{activeDispute?.description}</Typography>
            </Grid>
						<Grid item style={{display:'flex',gap:'1rem'}}>
							<Box style={{display:'flex',alignItems:'center',gap:'1rem'}}>
								<Typography>
									{format(new Date(dateToBeUse()), "dd MMMM, y, h:mm a")}
								</Typography>
								<Typography>
									({calc_days(dateToBeUse())===0 ? 'Today' : calc_days(dateToBeUse()) + ' day ago'})
								</Typography>
							</Box>
							{IS_TAG_CHANGE_ALLOWED ? (
								<>
								  <TextField
									  id='tag-select'
										required
										variant='outlined'
										size='small'
										select
										label='Change business vertical'
										value={buttonResponse}
										onChange={handleBusinessVerticalChange}
										SelectProps={{
											native: true,
										}}
										InputLabelProps={{ shrink: true }}
										style={{width: '200px'}}
									>
										<option value=''>-Select-</option>
										{['OCIL', 'OLFS'].map((item,index)=>{
											return (
												<option key={index} value={item}>{item}</option>
											)
										})}
									</TextField>
								</>
							) : (
								<>
								  {((activeDispute.status === RESPONDENT_INPROGRESS && IS_GRC) || 
										(activeDispute.status === IO_INPROGRESS && IS_ARBITRATOR) || 
										(activeDispute.status === MD_INPROGRESS && IS_IO)) ? (
										<Button
											color="primary"
											style={{textDecoration:'underline'}}
											onClick={()=> setResume(true)}
										>
											Resume Response
										</Button>
									) : (
										<Button
											className={classes.button}
											variant="outlined"
											onClick={handleClickRecordResponse}
											style={{textTransform: 'none'}}
											disabled={
												(!IS_END_USER && activeCase?.case_status === 'review_complete') || 
												activeDispute.status === 'closed' || 
												activeDispute.status === RESPONDENT_INPROGRESS || 
												activeDispute.status === IO_INPROGRESS ||
												activeDispute.status === MD_INPROGRESS ||
												(viewer_role !== getOrixRole(activeDispute?.orix_status) && !IS_END_USER)
											}
										>
											{IS_END_USER ? 'Write to us' : 'Record Response'}
										</Button>
									)}
									{!IS_END_USER && (
										<>
											{activeDispute?.orix_status === 'GRC_after_GRO' && (viewer_role === getOrixRole(activeDispute?.orix_status)) ? (
												<Button
													variant="contained"
													color="primary"
													style={{padding:'5px 15px'}}
													onClick={handleCloseGrievance}
													disabled={activeDispute.status === 'closed' || (IS_GRC && activeDispute?.date_closed_by_grc)}
												>
													Close Grievance
												</Button>
											) : (
												<TextField
													required
													variant='outlined'
													size='small'
													select
													placeholder='-Select-'
													value={buttonResponse}
													onChange={handleClickButtonResponse}
													SelectProps={{
														native: true,
													}}
													InputLabelProps={{ shrink: true }}
													// style={{width: '50%'}}
													disabled={
														activeDispute.status === 'closed' ||
														(viewer_role !== getOrixRole(activeDispute?.orix_status) && !IS_END_USER)
													}
												>
													<option value=''>-Select-</option>
													{respondOptions.map((item,index)=>{
														return (
															<option key={index} value={item}>{item}</option>
														)
													})}
												</TextField>
											)}
											
										</>
									)}
								</>
							)}
							{/* {IS_END_USER ? (
								(activeDispute?.openable && (calc_days(activeDispute?.date_closed_by_grc) <= 30)) && (
									<>
										<Button
											variant="contained"
											color="primary"
											style={{padding:'5px 15px'}}
											onClick={handleReopenGrievance}
										>
											Reopen
										</Button>
									</>
								)
							) : (
								<>
									<Button
										variant="contained"
										color="primary"
										style={{padding:'5px 15px'}}
										onClick={handleCloseGrievance}
										disabled={activeDispute.status === 'closed' || (IS_GRC && activeDispute?.date_closed_by_grc)}
									>
										Close Grievance
									</Button>
								</>
							)} */}
						</Grid>
					</Grid>
					{!IS_TAG_CHANGE_ALLOWED && (
					  <div style={{display:'flex',gap:'1rem', justifyContent: 'flex-end', marginTop: '1rem'}}>
							{!IS_END_USER && (
								<>
									{(['Rejected', 'Partially Rejected', 'Agree with GRC', 'Disagree with GRC', 'Agree with ORIX', 'Disagree with ORIX'].includes(buttonResponse)) ? (
										<>
										  {['Rejected', 'Partially Rejected'].includes(buttonResponse) && (
												<TextField
													required
													variant='outlined'
													size='small'
													select
													label='Reason'
													placeholder='-Select-'
													value={reasonForRejection}
													onChange={(event)=> setReasonForRejection(event.target.value)}
													SelectProps={{
														native: true,
													}}
													InputLabelProps={{ shrink: true }}
													style={{width: '40%', maxWidth: '250px'}}
												>
													<option value=''>-Select-</option>
													{reasonForRejectionOptions.map((item,index)=>{
														return (
															<option key={index} value={item}>{item}</option>
														)
													})}
												</TextField>
											)}
											<Button
												variant="contained"
												color="primary"
												style={{padding:'5px 15px'}}
												onClick={handleForwardGrievance}
											>
												Submit
											</Button>
										</>
									) : (
                    buttonResponse !== '' && (
                      <>
                        <Button
                          variant="contained"
                          color="primary"
                          style={{padding:'5px 15px'}}
                          onClick={handleCloseGrievance}
                          disabled={activeDispute.status === 'closed' || (IS_GRC && activeDispute?.date_closed_by_grc)}
                        >
                          Close Grievance
                        </Button>
                      </>
                    )
                  )}
								</>
							)}
						</div>
					)}
					<Box style={{height:'2rem'}}/>
					<Grid container spacing={2}>
						<Grid item lg={6} md={6} sm={6} xs={12} style={{ display: "flex" }}>
							<ComplainantDetails 
								title={activeDispute.name.split("&")[0]}
								tag={activeDispute.status === 'closed' ? 'Complaint Resolved' : 'Complaint in progress'}
								complainantData={complainantData}
							/>
						</Grid>
						<Grid item lg={6} md={6} sm={6} xs={12} style={{ display: "flex" }}>
							<TrackProgress />
						</Grid>
					</Grid>
				</Grid>
      </Grid>
    );
  }
